import BackOfCard from './BackOfCard';

export default BackOfCard;
